import request from "@/plugins/axios";
export class InsideService {
  // 获取订阅事件列表
  static getEventSubscribeList(applicationId, eventType, page, pageSize) {
    return request.get(`/Opencloud/EventCompSubscribe/EventCompSubscribePageList?applicationId=${applicationId}&eventType=${eventType}&page=${page}&pageSize=${pageSize}`);
  }
  // 分组获取全部事件
  static getEventTypeGroupList() {
    return request.get(`/Opencloud/EventCompSubscribe/EventTypeGroupList`);
  }
  // 获取已添加的应用事件订阅
  static getSubscribeGroup(applicationId) {
    return request.get(`/Opencloud/EventCompSubscribe/ApplicationEventCompSubscribe?applicationId=${applicationId}`);
  }
  // 添加事件订阅
  static addEventSubscribe(params) {
    return request.post(`/Opencloud/EventCompSubscribe/AddBatchEventCompSubscribe`, params);
  }
  // 删除事件订阅
  static deleteEventSubscribe(id) {
    return request.post(`/Opencloud/EventCompSubscribe/EventCompSubscribe?id=${id}`);
  }
}
